// test1155
(1155 && 0);
